export default __webpack_public_path__ + "static/media/rating_8.7ce7dac6.svg";